import { useEffect, useState } from "react";
import pagesApi from "./admincomponents/PagesApi";

export default function Faq() {
  const defaultFaqs = [
    {
      question: "What are the products from Futura Bio Labs intended for?",
      answer:
        "All products sold by Futura Bio Labs are strictly intended for in-vitro research and laboratory use only. They are not intended for human or animal consumption, and are not to be used as food, drugs, cosmetics, or any form of supplementation. By purchasing from Futura Bio Labs, you acknowledge and agree to use our products solely for legitimate research purposes.",
    },
    {
      question: "Are your products regulated or approved by the FDA?",
      answer:
        "No, our products are not approved by the FDA and are sold strictly for research purposes only.",
    },
    {
      question: "Can your products be used for self-experimentation or personal supplementation?",
      answer:
        "No, our products are not intended for human use, self-experimentation, or personal supplementation of any kind.",
    },
    {
      question: "Do I need specific credentials to purchase from Futura Bio Labs?",
      answer:
        "We recommend that only qualified researchers or laboratory professionals purchase and handle our products.",
    },
    {
      question: "What forms of payment do you accept?",
      answer:
        "We accept major credit and debit cards, as well as select cryptocurrency payments. All transactions are processed securely at checkout.",
    },
    {
      question: "How long does it take to receive my order?",
      answer:
        "Orders typically ship within 1-2 business days after purchase. Orders placed on Saturday or Sunday will ship the following Monday. Delivery times vary depending on your location.",
    },
    {
      question: "Do you accept returns or issue refunds?",
      answer:
        "Due to the nature of our research products, we do not accept returns once an order has shipped. If your order arrives damaged or incorrect, please contact our support team.",
    },
  ];
  const [content, setContent] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  
  useEffect(() => {
    pagesApi
      .get("faq")
      .then(setContent)
      .catch(() => setContent({}))
      .finally(() => setIsLoading(false));
  }, []);
  
  const faqs = content?.faqItems?.length === 7 ? content.faqItems : defaultFaqs;
  
  const [openIndex, setOpenIndex] = useState(null);
  
  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };
  
  if (isLoading) {
    return (
      <section className="w-full bg-white py-[51px] px-[25px] md:px-[51px] mt-24 md:mt-32">
        <div className="max-w-[1200px] mx-auto flex flex-col items-center justify-center py-20">
          <svg
            className="animate-spin h-8 w-8 text-teal-500"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            />
          </svg>
          <p className="text-gray-500 text-sm mt-4">Loading FAQs...</p>
        </div>
      </section>
    );
  }
  
  return (
    <section className="w-full bg-white py-[51px] px-[25px] md:px-[51px] mt-24 md:mt-32">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="text-gray-800 font-semibold text-[25px] md:text-[38px] mb-[26px]">
          {content?.faqPageTitle || "Futura Bio Labs – FAQ"}
        </h2>
  
        <div className="flex flex-col gap-4">
          {faqs.map((faq, i) => {
            const isOpen = openIndex === i;
            return (
              <div key={i} className="border border-gray-300 rounded-md">
                <button
                  onClick={() => toggle(i)}
                  className="w-full flex items-center gap-3 text-left text-gray-700 text-[17px] p-[7px]"
                >
                  <span className="flex-shrink-0 text-teal-500">
                    {isOpen ? (
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                      </svg>
                    ) : (
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                      </svg>
                    )}
                  </span>
                  <span>{faq.question}</span>
                </button>

                <div
                  className="overflow-hidden transition-[max-height] duration-[250ms] ease-in-out"
                  style={{ maxHeight: isOpen ? "500px" : "0px" }}
                >
                  <p className="text-gray-500 text-[17px] p-[7px] pt-0">
                    {faq.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}